// covered-by: frontends/carrie/src/routes/ask-puntt/__tests__/campaigns.test.tsx
// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectPage.test.tsx
import { Badge } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

type AskV2ProjectDoneBadgeProps = {
  /** Project `doneAt`. Null or missing while the project is still open. */
  doneAt: string | Date | null | undefined;
  /** Unique on the page. List cards suffix the project id; the rail uses one id. */
  testId: string;
};

/**
 * Soft status chip for a project that has been marked done.
 * Renders nothing while `doneAt` is unset so both call sites share one branch.
 */
export function AskV2ProjectDoneBadge({
  doneAt,
  testId,
}: AskV2ProjectDoneBadgeProps) {
  const { t } = useTranslation("ui");
  if (doneAt == null) return null;

  return (
    <Badge
      size="1"
      variant="soft"
      color="green"
      // why: a flex-col parent (the rail) stretches this chip to the container; w-fit keeps the green on the label
      className="inline-flex w-fit shrink-0 self-start"
      role="status"
      data-testid={testId}
      aria-label={t("askV2.openItems.markedDone")}
    >
      {t("askV2.openItems.doneBadge")}
    </Badge>
  );
}
